var _circle, _circle2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgRippleLoader = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 200,
  height: 200,
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 100 100",
  preserveAspectRatio: "xMidYMid",
  className: "lds-ripple",
  style: {
    background: "0 0"
  }
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 50,
  cy: 50,
  r: 9.58,
  fill: "none",
  stroke: "#54FABD",
  strokeWidth: 5
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "r",
  calcMode: "spline",
  values: "0;40",
  keyTimes: "0;1",
  dur: 2,
  keySplines: "0 0.2 0.8 1",
  begin: "-1s",
  repeatCount: "indefinite"
}), /*#__PURE__*/React.createElement("animate", {
  attributeName: "opacity",
  calcMode: "spline",
  values: "1;0",
  keyTimes: "0;1",
  dur: 2,
  keySplines: "0.2 0 0.8 1",
  begin: "-1s",
  repeatCount: "indefinite"
}))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  cx: 50,
  cy: 50,
  r: 30.473,
  fill: "none",
  stroke: "#54FABD",
  strokeWidth: 5
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "r",
  calcMode: "spline",
  values: "0;40",
  keyTimes: "0;1",
  dur: 2,
  keySplines: "0 0.2 0.8 1",
  begin: "0s",
  repeatCount: "indefinite"
}), /*#__PURE__*/React.createElement("animate", {
  attributeName: "opacity",
  calcMode: "spline",
  values: "1;0",
  keyTimes: "0;1",
  dur: 2,
  keySplines: "0.2 0 0.8 1",
  begin: "0s",
  repeatCount: "indefinite"
}))));

export default SvgRippleLoader;